import {
    Button,
    Checkbox,
    FormControlLabel,
    MuiThemeProvider,
    TextField,
    Tooltip,
    createMuiTheme,
} from "@material-ui/core";
import { ArrowDownward, ArrowUpward, Delete, Edit } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls";
import Table, { buttonsStyle } from "../../../components/tables/table";
import { deleteForm, getFormById, postForm, updateForm } from "../../../../api/form";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory, useParams } from "react-router-dom";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { Col, Row } from "react-bootstrap";
import { TableHeader } from "../../../../utils/helpers";
import { EditQuestionDialog } from "../../../components/dialogs/forms/EditQuestionDialog";
import { EditFormInfo } from "../../../../utils/formUtils";
import { changes, setChanges } from "../../../../utils/globals";

const theme = createMuiTheme({
	palette: {
		secondary: {
			main: "#F64E60",
		},
	},
});

export const EditForm = () => {
    const [form, setForm] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(-1);

    const [refresh, setRefresh] = useState(false);
    const history = useHistory();
    const formId = useParams().id;

    // const [changes, setChanges] = useState(-2);
    useEffect(() => setChanges(-2), []);
    useEffect(() => {
        setChanges(changes+1);
    }, [form]);
    
    useEffect(() => {
        if (formId) {
            getFormById(formId)
                .then((res) => {
                    setForm(res.data);
                })
                .catch((error) => {
                    alertError({
                        error,
                        customMessage: "Could not obtain form"
                    });
                    setChanges(0);
                    history.push('/forms');
                });
        }
        else {
            setForm({
                texts: [],
                tests: [],
                yesNo: []
            })
        }
    }, []);

    useEffect(() => {
        setRefresh(false);
    }, [refresh]);

    function save() {
        if (!form?._id) {
            postForm(form)
                .then((res) => {
                    if (res.status === 201) {
                        alertSuccess({
                            title: "Success!",
                            customMessage: "Form saved!"
                        })
                        setChanges(0);
                        history.push("/forms");
                    }
                })
                .catch((error) => {
                    alertError({
                        error,
                        customMessage: "Could not save form."
                    })
                })
        }
        else {
            updateForm(form._id, form)
                .then((res) => {
                    if (res.status === 200) {
                        alertSuccess({
                            title: "Success!",
                            customMessage: "Form saved!"
                        })
                        setChanges(0);
                        history.push("/forms");
                    }
                })
                .catch((error) => {
                    alertError({
                        error,
                        customMessage: "Could not save form."
                    })
                })
        }
    }

    return (
        <Card>
            <CardHeader title={form?._id?'Form: ' + (form.name):'New form'}>
                <div className="mt-5">
                    <Button
                        onClick={() => {
                            if (changes <= 0) history.push('/forms');
                            else setOpenConfirmDialog(1);
                        }}
                        variant="outlined"
                        style={{ marginRight: "20px" }}
                    >
                        Back
                    </Button>
                    <Button
                        onClick={() => save()}
                        variant="outlined"
                        color="primary"
                        style={{ marginRight: "20px" }}
                    >
                        Save form
                    </Button>
                    <ConfirmDialog
                        title={
                            "Are you sure you want to go back? You will lose all your changes"
                        }
                        open={openConfirmDialog === 1}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            setChanges(0);
                            history.push("/forms")
                        }}
                    />
                    { formId && (
                        <>
                        <MuiThemeProvider theme={theme}>
                            <Button
                                onClick={() => setOpenConfirmDialog(2)}
                                variant="outlined"
                                color="secondary"
                                style={{ marginRight: "20px" }}
                            >
                                Delete form
                            </Button>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    marginLeft: "auto",
                                }}
                            ></div>
                        </MuiThemeProvider>
                        </>
                    )}

                    <ConfirmDialog
                        title={
                            "Are you sure you want to delete this form?"
                        }
                        open={openConfirmDialog === 2}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deleteForm(formId)
                                .then((res) => {
                                    if (
                                        res.status === 204 ||
                                        res.status === 200
                                    ) {
                                        alertSuccess({
                                            title: "Deleted!",
                                            customMessage:
                                                "Form deleted successfully",
                                        });
                                        setChanges(0);
                                        history.push("/forms");
                                    }
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage:
                                            "Could not delete form.",
                                    });
                                });
                        }}
                    />
                </div>
                </CardHeader>
            <CardBody>
                <EditFormInfo form={form} setForm={setForm}/>
            </CardBody>
        </Card>
    )
}